<div *ngIf="totalCount > 0 && !hideLoading" class="table-footer d-flex justify-content-between align-items-center">
	<div class="records-count d-sm-block d-none text-secondary">
		Showing {{pager.startIndex+1}} to {{pager.endIndex+1}} of {{totalCount}} entries
	</div>
	<nav class="pages">
		<ul class="pagination">
			<li [ngClass]="{ 'disabled': currentPage === 1 }" class="page-item"><a href="javascript:;" class="page-link"
					(click)="getData(currentPage-1)">Previous</a></li>
			<li [ngClass]="{ 'custom-disabled active': currentPage === page }" class="page-item"
				*ngFor="let page of pager.pages"><a class="page-link" href="javascript:;" (click)="getData(page)">{{page}}</a>
			</li>
			<li [ngClass]="{ 'disabled': currentPage + 1 > totalRecordsPage }" class="page-item"><a class="page-link"
					href="javascript:;" (click)="getData(currentPage+1)">Next</a></li>
		</ul>
	</nav>
</div>